import { useMemo } from 'react';
import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { isValidProductLine } from '../../utils/typeguards';
import { useProductInventory } from './useProductInventory';
const productLinePriority = ['OPERATIONS', 'SERVICE', 'SALES', 'MARKETING', 'CMS', 'COMMERCE'];
export const useSortedProductInventory = () => {
  const {
    products: productInventory,
    loading,
    error
  } = useProductInventory();
  const sortedProductInventory = useMemo(() => {
    if (!productInventory) {
      return [];
    }
    return [...productInventory].sort((a, b) => {
      if (a.productLevel === 'BASIC' || !a.productLevel || !currentOrderedProductLevels.includes(a.productLevel)) {
        return 1;
      }
      if (b.productLevel === 'BASIC' || !b.productLevel || !currentOrderedProductLevels.includes(b.productLevel)) {
        return -1;
      }

      // If multiple products have the same product level, sort by bundled products / product line priority
      if (a.productLevel === b.productLevel) {
        var _a$bundledProducts, _b$bundledProducts;
        // bundled products have higher priority
        const aHasBundledProducts = !!(a.bundle && (_a$bundledProducts = a.bundledProducts) !== null && _a$bundledProducts !== void 0 && _a$bundledProducts.length);
        const bHasBundledProducts = !!(b.bundle && (_b$bundledProducts = b.bundledProducts) !== null && _b$bundledProducts !== void 0 && _b$bundledProducts.length);
        if (aHasBundledProducts && !bHasBundledProducts) {
          return -1;
        }
        if (bHasBundledProducts && !aHasBundledProducts) {
          return 1;
        }

        // Handle undefined productLine gracefully
        const aProductLineIndex = isValidProductLine(a.productLine) ? productLinePriority.indexOf(a.productLine) : -1;
        const bProductLineIndex = isValidProductLine(b.productLine) ? productLinePriority.indexOf(b.productLine) : -1;
        return aProductLineIndex - bProductLineIndex;
      }

      // sort by product level priority, Ent being the highest priority
      return currentOrderedProductLevels.indexOf(b.productLevel) - currentOrderedProductLevels.indexOf(a.productLevel);
    });
  }, [productInventory]);
  return {
    sortedProductInventory,
    loading,
    error
  };
};